import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading = this.isLoadingSubject.asObservable();

  show(): void {
    this.setLoading(true);
  }

  hide(): void {
    this.setLoading(false);
  }

  private setLoading(isLoading: boolean): void {
    setTimeout(() => this.isLoadingSubject.next(isLoading));
  }
}
